import {AnimatePresence,motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiX,FiMinus,FiPlus,FiArrowUpRight} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20would%20like%20to%20place%20an%20order%20for%20the%20pieces%20in%20my%20bag.';

function BagDrawer({isOpen,items,onClose,onChangeQuantity}) {
  const total = items.reduce((s,i) => s + i.price * i.quantity,0);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[70]">
          <motion.button className="absolute inset-0 bg-[#1F1B17]/50 backdrop-blur-sm" onClick={onClose} initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} aria-label="Close" />
          <motion.aside initial={{x: '100%'}} animate={{x: 0}} exit={{x: '100%'}} transition={{type: 'tween',duration: 0.3}} className="absolute right-0 top-0 h-full w-full max-w-md bg-[#F7F2EA] flex flex-col p-8 overflow-y-auto">
            <div className="flex items-center justify-between pb-6 border-b border-[#DDD3BE]">
              <div>
                <p className="eyebrow mb-2" style={{color: '#1F3D2E'}}>Your selection</p>
                <h2 className="font-display text-3xl text-[#1F1B17]">Your bag <span className="font-sans text-sm text-[#7A6E62]">({items.length})</span></h2>
              </div>
              <button onClick={onClose} aria-label="Close" className="text-2xl text-[#1F1B17] hover:text-[#1F3D2E] transition"><SafeIcon icon={FiX} /></button>
            </div>
            {items.length === 0 ? (
              <div className="flex-1 flex flex-col items-center justify-center text-center">
                <span className="font-display text-5xl text-[#B87333] mb-4">01</span>
                <h3 className="font-display text-2xl text-[#1F1B17]">A little room for lovely.</h3>
                <p className="mt-3 font-sans text-sm text-[#7A6E62]">Your bag is waiting for something special.</p>
                <button onClick={onClose} className="btn-gold mt-8">Explore the edit</button>
              </div>
            ) : (
              <>
                <div className="flex-1 overflow-y-auto">
                  {items.map(item => (
                    <div key={item.id} className="py-5 flex gap-4 border-b border-[#DDD3BE]">
                      <img src={item.image} alt="" className="w-20 h-28 object-cover" />
                      <div className="flex-1 relative">
                        <h3 className="font-display text-lg text-[#1F1B17]">{item.name}</h3>
                        <p className="mt-1 font-sans text-xs text-[#7A6E62]">{item.tone}</p>
                        <strong className="font-sans text-sm text-[#1F3D2E]">₹{item.price}</strong>
                        <div className="absolute right-0 bottom-0 flex items-center gap-3">
                          <button onClick={() => onChangeQuantity(item.id,-1)} className="grid place-items-center w-8 h-8 border border-[#DDD3BE] hover:border-[#1F3D2E] transition"><SafeIcon icon={FiMinus} className="text-xs" /></button>
                          <span className="font-sans text-sm">{item.quantity}</span>
                          <button onClick={() => onChangeQuantity(item.id,1)} className="grid place-items-center w-8 h-8 border border-[#DDD3BE] hover:border-[#1F3D2E] transition"><SafeIcon icon={FiPlus} className="text-xs" /></button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="pt-6">
                  <p className="flex justify-between font-sans text-base text-[#1F1B17]"><span>Subtotal</span><strong>₹{total.toFixed(2)}</strong></p>
                  <p className="mt-2 font-sans text-[10px] text-[#7A6E62]">Checkout happens personally over WhatsApp.</p>
                  <a href={WA} target="_blank" rel="noreferrer" className="btn-gold w-full justify-between mt-5">
                    Continue on WhatsApp <SafeIcon icon={FiArrowUpRight} />
                  </a>
                </div>
              </>
            )}
          </motion.aside>
        </div>
      )}
    </AnimatePresence>
  );
}

export default BagDrawer;
